import withRenderModal from 'hocs/withRenderModal'

import MainModal from 'modals/MainModal'

import { useModal } from 'hooks'
import styled from 'styled-components'
import TypographyPrimary from 'components/Typography/Primary'
import TypographySecondary from 'components/Typography/Secondary'
import { ButtonPrimary } from 'components/Button/Button'
import { ImageInterface } from './ImagesHistoryList'
import LabeledCopyButton from 'components/CopyButton/LabeledCopyButton'

type ImagesModalProp = {
    data: ImageInterface
}

const ImagesModal = ({ data }: ImagesModalProp) => {
    const { width, height, url, prompt, style, model, cUrl } = data

    const { closeModal } = useModal()

    const handleCloseModal = () => {
        closeModal('images-modal')
    }

    return (
        <MainModal onClose={handleCloseModal} title={''} customButtons={<></>}>
            <StyledBody>
                <StyledImageWrapper>
                    <StyledImg src={url} />
                </StyledImageWrapper>

                <StyledInfo>
                    <StyledColumn>
                        <TypographyPrimary size='large' value={prompt} semiBold />
                        <TypographyPrimary size='x-large' value={model} semiBold />
                        <TypographyPrimary size='large' value={style} semiBold />
                    </StyledColumn>

                    <StyledColumn>
                        <StyledRow>
                            <TypographySecondary size='small' value='Width:' semiBold />
                            <TypographyPrimary size='small' value={width} semiBold />
                        </StyledRow>
                        <StyledRow>
                            <TypographySecondary size='small' value='Height:' semiBold />
                            <TypographyPrimary size='small' value={height} semiBold />
                        </StyledRow>
                        <StyledRow>
                            <TypographySecondary size='small' value='Guidance scale:' semiBold />
                            <TypographyPrimary size='small' value='2' semiBold />
                        </StyledRow>
                        <StyledRow>
                            <TypographySecondary size='small' value='Steps:' semiBold />
                            <TypographyPrimary size='small' value='10' semiBold />
                        </StyledRow>
                    </StyledColumn>

                    <StyledButtonsWrapper>
                        <StyledColumn>
                            <LabeledCopyButton value={cUrl} label='Copy cURL' />

                            <StyledA target='_blank' href={url} download='Photo' rel='noreferrer'>
                                <StyledDownloadButton>Download</StyledDownloadButton>
                            </StyledA>
                        </StyledColumn>
                    </StyledButtonsWrapper>
                </StyledInfo>
            </StyledBody>
        </MainModal>
    )
}

export default withRenderModal('images-modal')(ImagesModal)

const StyledBody = styled.div`
    display: flex;

    width: 60vw;
    max-width: 60vw;
    height: 100%;

    padding-bottom: 10px;

    @media (max-width: 900px) {
        gap: 20px;
        flex-direction: column;
    }
`
const StyledImg = styled.img`
    object-fit: contain;
    width: 100%;
    border-radius: 8px;
`
const StyledInfo = styled.div`
    width: 100%;
    min-width: 200px;
    max-width: 400px;
    height: 100%;

    display: flex;
    flex-direction: column;
    gap: 16px;

    padding: 0 20px;
`
const StyledImageWrapper = styled.div`
    /* margin: 0 20px; */

    width: 100%;
    padding: 0 20px;
`

const StyledRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 4px;
`
const StyledColumn = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
`
const StyledButtonsWrapper = styled.div`
    margin-top: auto;
`
const StyledA = styled.a`
    width: 100%;
`
const StyledDownloadButton = styled(ButtonPrimary)`
    width: 100%;
`
